import {callAPI} from './callApi';
import {RestApiMethod} from '../../const/dataEnum';
import {
  API_MESSAGE_ALL,
  API_MESSAGE_BY_RECEIVER,
  API_MESSAGE_BY_SENDER,
  API_MESSAGE_BY_SENDER_AND_STATUS,
  API_MESSAGE_CREATE,
  API_MESSAGE_DELETE,
  API_MESSAGE_UPDATE,
} from '../../const/Api';

export const fetchALLMessage = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_MESSAGE_ALL,
    });
    console.log('Response Data Get All ', res.data);
    return res.data;
  } catch (error) {
    console.log('fetchALLMessage Error:', error.message);
  }
};

export const fetchMessageBySender = async (senderId) => {
  if (!senderId || senderId === 'number' || senderId === null) return null;
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_MESSAGE_BY_SENDER + `/${senderId}`,
    });
    console.log('fetchMessage by senderId:', res.data);
    return res.data;
  } catch (error) {
    console.log('fetchMessageBySender Error:', error.message);
  }
};

export const fetchMessageBySenderAndStatus = async (senderId, status) => {
  const res = await callAPI({
    method: RestApiMethod.GET,
    url: API_MESSAGE_BY_SENDER_AND_STATUS + senderId + '/' + status,
  });
  console.log('fetchMessage by senderId and status:', res.data);
};

export const fetchMessageByReceiver = async (receiverId, reviewPeriodId) => {
  if (!receiverId || receiverId === 'number' || receiverId === null) return null;
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_MESSAGE_BY_RECEIVER + `/${receiverId}?reviewPeriodId=${reviewPeriodId}`,
    });
    return res.data;
  } catch (error) {
    console.error('fetchMessageByReceiver Error:', error.message);
  }
};

export const fetchUnreadMessagesByReceiver = async (receiverId, periodId) => {
  if (!receiverId || typeof receiverId !== 'number' || receiverId === null) return null;
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_MESSAGE_BY_RECEIVER}/${receiverId}/${periodId}?isRead=false`,
    });
    console.log('Unread messages for receiverId:', res.data);
    return res.data;
  } catch (error) {
    console.error('fetchUnreadMessagesByReceiver Error:', error.message);
  }
};

export const createMessage = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_MESSAGE_CREATE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('createMessage Error:', error.message);
    return null;
  }
};

export const updateMessage = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_MESSAGE_UPDATE,
      data,
    });
    return res;
  } catch (error) {
    console.log('updateMessage Error:', error.message);
    return null;
  }
};

export const deleteMessage = async (id) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_MESSAGE_DELETE + id,
    });
    return res.data;
  } catch (error) {
    console.error('deleteMessage Error:', error.message);
    return null;
  }
};

const MessageApi = {
  fetchALLMessage,
  fetchMessageBySender,
  fetchMessageBySenderAndStatus,
  fetchMessageByReceiver,
  createMessage,
  updateMessage,
  deleteMessage,
};

export default MessageApi;
